export interface ChartAxes {
  xAxis: string;
  yAxis: string;
}

/**
 * Extract chart axes from data array.
 * If xAxis/yAxis provided, use those. Otherwise infer from first object keys.
 *
 * @param data - Array of data records
 * @param xAxis - Optional explicit x-axis field name
 * @param yAxis - Optional explicit y-axis field name
 * @returns ChartAxes with xAxis and yAxis field names
 */
export function extractChartAxes(data: Record<string, unknown>[], xAxis?: string, yAxis?: string): ChartAxes {
  const firstRecord = data[0];
  const keys = firstRecord ? Object.keys(firstRecord) : [];

  return {
    xAxis: xAxis ?? keys[0] ?? 'x',
    yAxis: yAxis ?? keys[1] ?? 'y',
  };
}
